import { Component } from "react";
import LocalMain from "../pages/LocalMain.js";

class ErrorBoundary extends Component {

    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // log the error
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <LocalMain {...this.props}/>
        }
        return this.props.children;
    }
}

export default ErrorBoundary;